import { render, staticRenderFns } from "./logDetail.vue?vue&type=template&id=ec204708&scoped=true"
import script from "./logDetail.vue?vue&type=script&lang=js"
export * from "./logDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec204708",
  null
  
)

export default component.exports